export const COMPETITION_START_DATE = "2025-06-01";
export const EARLY_BIRD_DAYS = 30;

export const PRICING = {
  Student: "60.00",
  Professional: "100.00"
};
export const PAYMENT_LINK = "testlink.com";
